import Axios from "@/plugins/Axios";
import Disciplina from "@/Models/Disciplina";

export class DisciplinasService {
  async atualizarDisciplina(disciplina) {
    const response = await Axios().put(`disciplinas/${disciplina.id}`, disciplina);

    return response.data;
  }

  async criarDisciplina(disciplina) {
    const response = await Axios().post("disciplinas", disciplina);

    return response.data;
  }

  async deletarDisciplina(disciplina) {
    const response = await Axios().delete(`disciplinas/${disciplina.id}`);

    return response.data;
  }

  async listarDisciplinas(gestao_id) {
    const response = await Axios().get(`disciplinas/listar/${gestao_id}`);

    const disciplinas = response.data.map((disciplina) => new Disciplina(disciplina));
    return disciplinas;
  }

  async listarDisciplinasAEE() {
    const response = await Axios().get("disciplinas/educacao-inclusiva");

    const disciplinas = response.data.map((disciplina) => new Disciplina(disciplina));
    return disciplinas;
  }

  async listarDisciplinasComPlanoPorSerie(serie_id, turno_id = null) {
    const query = turno_id ? `?turno_id=${turno_id}` : "";
    const response = await Axios().get(`disciplinas/planos/${serie_id}${query}`);

    const disciplinas = response.data.map((disciplina) => new Disciplina(disciplina));
    return disciplinas;
  }

  async recuperarDisciplina(disciplina) {
    return this.atualizarDisciplina({ ...disciplina, deleted_at: null });
  }

  async syncAll() {
    const response = await Axios().get("disciplinas");

    const disciplinas = response.data.map((disciplina) => new Disciplina(disciplina));
    return disciplinas;
  }

  async syncAllPaginated(pageNumber, query) {
    const response = await Axios().get(`disciplinas/paginate?page=${pageNumber}&query=${query}`);
    return response.data;
  }

  async listarAreasConhecimento() {
    const response = await Axios().get("disciplinas/areas-conhecimento");
    return response.data;
  }
}

export default new DisciplinasService();
